import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { TestimonialsRoutingModule } from './testimonials-routing.module';
import { TestimonialsListComponent } from './testimonials-list/testimonials-list.component';
import { TestimonialsCreateComponent } from './testimonials-create/testimonials-create.component';

@NgModule({
  declarations: [TestimonialsListComponent, TestimonialsCreateComponent],
  imports: [
    CommonModule,
    TestimonialsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class TestimonialsModule { }
